import { render, staticRenderFns } from "./download-cloud.vue?vue&type=template&id=5a4f29b0&"
import script from "./download-cloud.vue?vue&type=script&lang=js&"
export * from "./download-cloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports